"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneInputHook = void 0;
const ar = require('../constants/lang/ar.json');
const tr = require('../constants/lang/tr.json');
const es = require('../constants/lang/es.json');
const jp = require('../constants/lang/jp.json');
const pt = require('../constants/lang/pt.json');
const de = require('../constants/lang/de.json');
const zh = require('../constants/lang/cn.json');
const phoneInputHook = () => {
    const getLocals = (lang) => {
        switch (lang) {
            case 'ar':
                return ar;
            case 'de':
                return de;
            case 'pt':
                return pt;
            case 'tr':
                return tr;
            case 'es':
                return es;
            case 'ja':
                return jp;
            case 'zh':
                return zh;
            default:
                return undefined;
        }
    };
    return {
        getLocals,
    };
};
exports.phoneInputHook = phoneInputHook;
